import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { VisibilityProvider } from "./contexts/VisibilityContext";
import { ToastProvider } from "./contexts/ToastContext";
import AppLayout from "./components/AppLayout";
import ToastContainer from "./components/ToastContainer";
import LandingPage from "./pages/LandingPage";
import SignUpPage from "./pages/SignUpPage";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import HomePage from "./pages/Home";
import MyNotesPage from "./pages/MyNotesPage";
import NotificationsPage from "./pages/NotificationsPage";
import MessagesPage from "./pages/MessagesPage";
import SettingsPage from "./pages/SettingsPage";
import NotePage from "./pages/NotePage";
import PrivacyPolicyPage from "./pages/legal/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/legal/TermsOfServicePage";
import CommunityGuidelinesPage from "./pages/legal/CommunityGuidelinesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <SettingsProvider>
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignUpPage />} />
                <Route path="/verify-email" element={<VerifyEmailPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

                {/* Info pages (public) */}
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />

                {/* Legal pages (public) */}
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/terms" element={<TermsOfServicePage />} />
                <Route
                  path="/community-guidelines"
                  element={<CommunityGuidelinesPage />}
                />

                {/* Protected routes with persistent layout */}
                <Route
                  element={
                    <ProtectedRoute>
                      <VisibilityProvider>
                        <NotificationProvider>
                          <AppLayout />
                        </NotificationProvider>
                      </VisibilityProvider>
                    </ProtectedRoute>
                  }
                >
                  <Route path="/home" element={<HomePage />} />
                  <Route path="/notes" element={<MyNotesPage />} />
                  <Route
                    path="/notifications"
                    element={<NotificationsPage />}
                  />
                  <Route path="/messages" element={<MessagesPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/n/:noteId" element={<NotePage />} />
                </Route>
              </Routes>
              <ToastContainer />
          </SettingsProvider>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
